(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[369],{

/***/ 35940:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event",
      function () {
        return __webpack_require__(17732);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30754:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ event_Event; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./components/customizing/print/Print.styles.js
var Print_styles = __webpack_require__(32252);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
// EXTERNAL MODULE: ./hook/customizing/print/useTabStickyHandler.js
var useTabStickyHandler = __webpack_require__(15634);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/modern/useQuery.js + 7 modules
var useQuery = __webpack_require__(87633);
// EXTERNAL MODULE: ./common/queryKeys.js
var queryKeys = __webpack_require__(51586);
// EXTERNAL MODULE: ./api/apis.js
var apis = __webpack_require__(66887);
;// CONCATENATED MODULE: ./hook/event/useEventListQuery.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var useGetEventList = function(code) {
    return (0,useQuery/* useQuery */.a)({
        queryKey: [
            queryKeys/* QUERY_KEYS.EVENT.INDEX */.U.EVENT.INDEX,
            code
        ],
        queryFn: _asyncToGenerator(runtime_default().mark(function _callee() {
            var body, res, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ViewSet",
                            code: code
                        };
                        _ctx.next = 3;
                        return (0,apis/* EventPagesAPI */.SM)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.Code === "0000")) {
                            _ctx.next = 9;
                            break;
                        }
                        ;
                        return _ctx.abrupt("return", ((ref = res.Data) === null || ref === void 0 ? void 0 : ref.Row) || []);
                    case 9:
                        {
                            console.error(res === null || res === void 0 ? void 0 : res.message); // 에러 처리
                        }
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        })),
        enabled: !!code,
        retry: 1
    });
};

// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 22 modules
var es = __webpack_require__(64384);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./common/alert.js
var common_alert = __webpack_require__(55150);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/event/Event.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  max-width: 100%;\n  display: flex;\n  justify-content: center;\n\n  & figure {\n    max-width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}










// ✅ Next.js Router 사용

var HtmlWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-f614f5c9-0"
})(_templateObject());
var Event = function(param) {
    var dummyList = param.dummyList;
    var ref, ref1, ref2, ref3, ref4, ref5;
    var tabHeaderRef = (0,react.useRef)(null);
    var isSticky = (0,useTabStickyHandler/* useTabStickyHandler */.h)(tabHeaderRef).isSticky;
    var router = (0,next_router.useRouter)();
    var code = router.query.code; // /event/[code] 에서 code
    var ref6 = (0,react.useState)(0), activeIndex = ref6[0], setActiveIndex = ref6[1];
    var eventList = (dummyList === null || dummyList === void 0 ? void 0 : (ref = dummyList.event) === null || ref === void 0 ? void 0 : ref.data) || [];
    var truncate = function(text) {
        var maxLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 10;
        if (!text) return "";
        return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    };
    // ✅ URL의 code 기준으로 활성 탭 맞추기
    (0,react.useEffect)(function() {
        if (!eventList.length) return;
        if (code) {
            var foundIndex = eventList.findIndex(function(item) {
                return item.code === code;
            });
            if (foundIndex !== -1) {
                setActiveIndex(foundIndex);
                return;
            }
        }
        // code가 없거나 매칭되는 게 없으면 첫 번째 탭
        setActiveIndex(0);
    }, [
        code,
        eventList
    ]);
    // ✅ 실제로 사용할 code (API용)
    var selectedCode = eventList.length === 1 ? eventList[0].code : ((ref1 = eventList[activeIndex]) === null || ref1 === void 0 ? void 0 : ref1.code) || ((ref2 = eventList[0]) === null || ref2 === void 0 ? void 0 : ref2.code);
    // 이벤트 상세 데이터
    var ref7 = useGetEventList(selectedCode), eventDetail = ref7.data, isLoading = ref7.isLoading;
    // ✅ 탭 변경 시 URL을 /event/코드 형태로 변경
    var onChangeMainTab = function(index) {
        setActiveIndex(index);
        var item = eventList[index];
        if (!item) return;
        router.push("/event/".concat(item.code), undefined, {
            shallow: true
        });
    };
    // ✅ SEO용 메타 값 (이벤트별로 동적 처리)
    var pageTitle = (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.seoTitle) || (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.title) || ((ref3 = SeoMeta/* SeoMeta.event */.e.event) === null || ref3 === void 0 ? void 0 : ref3.title);
    var pageDesc = (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.seoDescription) || ((ref4 = SeoMeta/* SeoMeta.event */.e.event) === null || ref4 === void 0 ? void 0 : ref4.description);
    var pageKeyword = (eventDetail === null || eventDetail === void 0 ? void 0 : eventDetail.seoKeywords) || ((ref5 = SeoMeta/* SeoMeta.event */.e.event) === null || ref5 === void 0 ? void 0 : ref5.keywords);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        parent: "\uD648",
        sub: "\uC774\uBCA4\uD2B8",
        pageTitle: pageTitle,
        pageDesc: pageDesc,
        pageKeyword: pageKeyword,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                eventList.length > 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* TabContainer */.Xl, {
                    ref: tabHeaderRef,
                    isSticky: isSticky,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* TabHeader */.GK, {
                        children: eventList.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Print_styles/* TabItem */.E2, {
                                active: index === activeIndex,
                                onClick: function() {
                                    return onChangeMainTab(index);
                                },
                                children: truncate(item.title)
                            }, item.code);
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "no-event"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "\uB85C\uB529 \uC911..."
                    }) : eventDetail ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "pb-30 d-flex align-items-center justify-content-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mt-20 mb-20",
                                        children: eventDetail.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        "aria-label": "Share",
                                        className: "action-btn hover-up",
                                        onClick: function() {
                                            return navigator.clipboard.writeText(globalThis.location.href).then(function() {
                                                return (0,common_alert/* successAlert */.Cq)("\uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                                            });
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-share",
                                            style: {
                                                fontSize: "20px"
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ck-content",
                                    dangerouslySetInnerHTML: {
                                        __html: eventDetail.content
                                    }
                                })
                            })
                        ]
                    }) : null
                })
            ]
        })
    });
};
var mapStateToProps = function(state) {
    return {
        dummyList: state.dummyList
    };
};
/* harmony default export */ var event_Event = ((0,es/* connect */.$j)(mapStateToProps)(Event));


/***/ }),

/***/ 17732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_event_Event__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30754);


var EventPage = function(param) {
    var siteConfig = param.siteConfig;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_event_Event__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
};
/* harmony default export */ __webpack_exports__["default"] = (EventPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,9007,9774,2888,179], function() { return __webpack_exec__(35940); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);